import Spinner from "../../DesignSystem/Spinner";

// Suspense fallback for lazy route chunks; without it React renders nothing (a blank flash)
// while the chunk downloads. Centered so the surrounding shell stays put.
export default function RouteFallback() {
    return (
        <div className="flex h-screen w-full items-center justify-center">
            <Spinner variant="page" />
        </div>
    );
}
